{
	"common": {
		"actions": "Toiminnot",
		"add": "Lisää",
		"close": "Sulje",
		"backToPlanvera": "Takaisin PlanVeraan",
		"cancel": "Peruuta",
		"description": "Kuvaus",
		"export": "Vie",
		"filter": "Suodata {{column}}",
		"import": "Tuo",
		"name": "Nimi",
		"open": "Avaa",
		"quantity": "Määrä",
		"returnToPlanvera": "Palaa PlanVeraan",
		"save": "Tallenna",
		"scale": "Mittakaava",
		"signOut": "Kirjaudu ulos",
		"unit": "Yksikkö"
	},
	"units": {
		"C62": "kpl",
		"XPK": "pkt"
	},
	"sidebar": {
		"collapse": "Pienennä valikko",
		"expand": "Laajenna valikko",
		"files": "Tiedostot",
		"language": "Kieli",
		"openNavigation": "Avaa valikko",
		"products": "Tuotteet",
		"quantityList": "Määräluettelo",
		"takeoffs": "Määrälaskennat",
		"trash": "Roskakori",
		"workPackages": "Työpaketit"
	},
	"takeoffList": {
		"confirmDelete": "Siirretäänkö määrälaskenta \"{{name}}\" roskakoriin?",
		"confirmPermanentDelete": "Poistetaanko \"{{name}}\" pysyvästi? Kaikki mittaukset ja tiedot tuhotaan. Toimintoa ei voi perua.",
		"create": "Uusi",
		"delete": "Poista",
		"deletedOn": "Poistettu {{date}}",
		"permanentDelete": "Poista pysyvästi",
		"restore": "Palauta",
		"trash": "Roskakori",
		"trashEmpty": "Roskakori on tyhjä.",
		"descriptionLabel": "Kuvaus",
		"descriptionPlaceholder": "Kuvaus (valinnainen)",
		"disciplineLabel": "Ala",
		"discipline": {
			"electrical": "sähkö",
			"other": "muu",
			"plumbing": "LVI"
		},
		"duplicating": "Kopioidaan…",
		"emptyCta": "Luo määrälaskenta",
		"emptyDescription": "Luo ensimmäinen määrälaskenta aloittaaksesi määrien laskennan.",
		"emptyTitle": "Ei vielä määrälaskentoja",
		"fileCount": "{{count}} tiedostoa",
		"locked": "Lukittu · {{count}} tiedostoa ilman käyttöoikeutta",
		"title": "Määrälaskennat"
	},
	"frontpage": {
		"addFile": "Lisää tiedosto",
		"confirmDetachBody": "Tämä poistaa pysyvästi kaikki tiedoston {{name}} mittaukset, kohdistukset ja mittausdatan tästä määrälaskennasta. Toimintoa ei voi perua.",
		"deleteData": "Poista tiedot",
		"detachAndDelete": "Irrota ja poista tiedot",
		"editDescription": "Muokkaa kuvausta",
		"editScale": "Muokkaa mittakaavaa",
		"files": "Tiedostot",
		"groupAttached": "Liitetyt",
		"groupDetached": "Irrotettu — tiedot säilytetty",
		"groupTrashed": "Roskakorissa",
		"lockedNotice": "Määrälaskenta on tilapäisesti lukittu tiedostojen poiston tai käyttöoikeuksien synkronoinnin ajaksi. Yritä hetken kuluttua uudelleen lataamalla sivu.",
		"noFiles": "Ei vielä tiedostoja. Lisää piirustuksia tai IFC-malleja aloittaaksesi mittaamisen.",
		"quantityList": "Määräluettelo",
		"quantityTakeoff": "Määrälaskenta",
		"reattach": "Liitä uudelleen",
		"removeRetainedData": "Poista säilytetyt tiedot",
		"workPackages": "Työpaketit"
	},
	"flow": {
		"archivedReadOnly": "Arkistoitu projekti — vain luku",
		"collapseExport": "Yhdistä rivit viennissä",
		"exportDialogTitle": "Vie määräluettelo",
		"exportFilenameLabel": "Tiedoston nimi",
		"locked": "Määrälaskenta lukittu",
		"lockedDescription": "Käyttöoikeuksien synkronointi on kesken tai säilytetty tiedosto ei ole käytettävissä."
	},
	"quantityTable": {
		"code": "Paketti-ID / sähkönumero",
		"collapseAll": "Sulje kaikki rivit",
		"deleteRow": "Poista rivi",
		"expandAll": "Avaa kaikki rivit",
		"editRow": "Muokkaa riviä",
		"empty": "Ei vielä mitattuja ja kohdistettuja rivejä.",
		"mainProduct": "Päätuote",
		"measurements": "Mittaukset",
		"measurementLabel": "Mittaus {{index}}",
		"segmentLabel": "Osuus {{index}}",
		"contents": "Sisältö",
		"type": "Tyyppi",
		"typeTask": "Työ",
		"typeProduct": "Tuote",
		"products": "Tuotteet",
		"showDetails": "Näytä paketin tiedot",
		"showInViewer": "Näytä katselimessa",
		"system": "Järjestelmä",
		"tasks": "Työt",
		"classifySelection": "Luokittele ({{count}})",
		"selectAll": "Valitse kaikki rivit",
		"classification": "Luokittelu",
		"classificationFilter": "Suodata luokittelulla"
	},
	"browser": {
		"allPackages": "Kaikki paketit",
		"basicInfo": "Paketin perustiedot",
		"code": "Koodi",
		"date": "Päivämäärä",
		"emptyGroup": "Ei paketteja tässä ryhmässä.",
		"groupTree": "Pakettiryhmät",
		"groups": "Ryhmät",
		"installationInfo": "Tarkentavat tiedot",
		"modified": "Muokattu",
		"name1": "Nimi 1",
		"name2": "Nimi 2",
		"noChildPackages": "Ei liitettyjä paketteja",
		"ownPackages": "Omat paketit",
		"ungrouped": "Ryhmittelemättömät",
		"editMode": "Muokkaa",
		"addPackage": "Lisää paketti",
		"editGroups": "Muokkaa ryhmiä",
		"addGroup": "Lisää ryhmä",
		"addSubgroup": "Lisää alaryhmä",
		"editGroup": "Muokkaa ryhmää",
		"deleteGroup": "Poista ryhmä",
		"confirmDeleteGroup": "Poistetaanko tämä tyhjä ryhmä pysyvästi?",
		"groupCode": "Ryhmän tunnus (valinnainen)",
		"parentGroup": "Yläryhmä",
		"confirmMoveTitle": "Siirrä paketti",
		"confirmMovePackage": "Siirretäänkö {{package}} ryhmään {{group}}?",
		"movePackage": "Siirrä",
		"packageUnit": "Paketin yksikkö",
		"quantity": "Määrä",
		"sahkonro": "Sähkönro",
		"searchPlaceholder": "Hae nimellä, koodilla tai sähkönumerolla…",
		"sectionMainProducts": "Päätuotteet ({{count}} kpl)",
		"sectionPackages": "Paketit ({{count}} kpl)",
		"sectionProducts": "Tuotteet ({{count}} kpl)",
		"sectionWorks": "Työt ({{count}} kpl)",
		"toggleGroup": "Avaa tai sulje ryhmä",
		"tyonro": "Työnro",
		"variantCount": "Asennustavat",
		"createDialogIntro": "Paketti on luettelo työ- ja tuoterivejä yhtä perusyksikköä kohden.",
		"createPackage": "Luo paketti",
		"createTitle": "Luo työpaketti",
		"addProductRow": "Lisää tuoterivi",
		"addTaskRow": "Lisää työrivi",
		"basisUnit": "Perusyksikkö",
		"group": "Ryhmä",
		"importResult": "Tuotiin {{packages}} pakettia, {{versions}} uutta versiota.",
		"importResultPlaceholders": "{{count}} tuotetta luotiin paikkamerkkeinä (Sähkönumerot-synkronointi täydentää nimet myöhemmin).",
		"installation": "Asennustapa",
		"newPackage": "Uusi paketti",
		"noPackages": "Luettelossa ei ole vielä paketteja.",
		"noRows": "Ei vielä rivejä.",
		"packageCode": "Paketin tunnus",
		"packageCodeOptional": "Valinnainen",
		"packageName": "Paketin nimi",
		"product": "Tuote",
		"removeRow": "Poista rivi",
		"rowUnit": "Rivin yksikkö",
		"rowsPerBasisUnit": "Rivit (perusyksikköä kohden)",
		"duplicatePackage": "Monista",
		"editPackage": "Muokkaa",
		"editTitle": "Muokkaa työpakettia",
		"selectSubPackage": "Valitse paketti",
		"subPackage": "Alapaketti",
		"restorePackage": "Palauta",
		"retirePackage": "Poista käytöstä",
		"searchPackages": "Hae paketteja",
		"searchProducts": "Hae tuotteita",
		"selectProduct": "Valitse tuote",
		"createProduct": "Luo tuote",
		"loadMore": "Näytä lisää",
		"newProduct": "Uusi tuote",
		"noProducts": "Tuotteita ei löytynyt.",
		"productCode": "Tuotteen tunnus",
		"productName": "Tuotteen nimi",
		"productsTitle": "Tuotteet",
		"showRetired": "Näytä käytöstä poistetut",
		"source": "Lähde",
		"sourceOwn": "Oma",
		"sourceSahkonumerot": "Sähkönumerot",
		"sourceStul": "STUL",
		"subPackages": "Alapaketit",
		"taskName": "Työn nimi",
		"title": "Työpaketit",
		"favoritesGroup": "Suosikit",
		"favorite": "Suosikki"
	},
	"picker": {
		"addFiles_one": "Lisää {{count}} tiedosto",
		"addFiles_other": "Lisää {{count}} tiedostoa",
		"alreadyAttached": "Jo liitetty",
		"emptyFolder": "Tämä kansio on tyhjä.",
		"folderPath": "Kansiopolku",
		"title": "Lisää tiedostoja määrälaskentaan"
	},
	"workspace": {
		"loading": "Ladataan määrälaskentaa…",
		"unavailable": "Määrälaskenta ei ole käytettävissä",
		"unavailableDescription": "Määrälaskentaa ei voitu ladata."
	},
	"viewer": {
		"tools": {
			"navigate": "Liiku",
			"point": "Piste­mittaus",
			"route": "Pituus­mittaus",
			"area": "Alue­mittaus",
			"measure": "Mittaa",
			"navigateShort": "Navigoi",
			"pointShort": "Piste­mittaus",
			"routeShort": "Pituus­mittaus",
			"areaShort": "Alue­mittaus",
			"measureShort": "Mittaa"
		},
		"seedMethods": {
			"select": "Valinta",
			"draw": "Piirrä"
		},
		"pointModes": {
			"select": "Valinta",
			"add": "Lisää pisteitä"
		},
		"granularity": {
			"group": "Ryhmävalinta",
			"single": "Yksittäisvalinta"
		},
		"panel": {
			"expand": "Avaa paneeli",
			"collapse": "Pienennä paneeli",
			"selectionLayers": "Valinnan tasot",
			"showAllSelectionLayers": "Näytä kaikki valinnan tasot",
			"hideAllSelectionLayers": "Piilota kaikki valinnan tasot",
			"isolateSelectionLayers": "Näytä vain valinnan tasot",
			"restoreLayers": "Palauta tasot",
			"showLayer": "Näytä taso",
			"hideLayer": "Piilota taso",
			"showOnlyLayer": "Näytä vain tämä taso"
		},
		"layers": "Tasot",
		"nav": {
			"previousPage": "Edellinen sivu",
			"nextPage": "Seuraava sivu",
			"zoomIn": "Lähennä",
			"zoomOut": "Loitonna",
			"resetView": "Palauta näkymä",
			"exit": "Poistu"
		},
		"missingScaleWarning": "Piirustuksen mittakaavaa ei ole asetettu. Aseta mittakaava käyttääksesi mittauksia.",
		"clearSelection": "Tyhjennä valinta",
		"clearSelectionHint": "Tyhjennä valinta (Esc)",
		"scaleDialog": {
			"title": "Aseta piirustuksen mittakaava",
			"description": "Aseta piirustukselle mittakaava aloittaaksesi mittaamisen.",
			"editTitle": "Muuta piirustuksen mittakaavaa",
			"editDescription": "Valitse piirustukselle oikea mittakaava.",
			"saveChanges": "Tallenna",
			"recalculateWarning": "Mittaukset lasketaan uudelleen uudella mittakaavalla. Määrälaskennan olemassa olevat kohteet säilyttävät mittakaavan, jolla ne luotiin.",
			"close": "Sulje mittakaavaikkuna",
			"scaleLabel": "Mittakaava",
			"scalePlaceholder": "Valitse mittakaava",
			"customScaleLabel": "Mukautettu mittakaava",
			"customScalePlaceholder": "1:100",
			"customScaleHint": "Käytä suhdetta kuten 1:100.",
			"scaleUnitLabel": "Mittakaavan yksikkö",
			"scaleUnitPlaceholder": "Valitse yksikkö",
			"save": "Tallenna ja mittaa",
			"saving": "Tallennetaan…",
			"saved": "Piirustuksen mittakaava tallennettu",
			"saveError": "Piirustuksen mittakaavan tallennus epäonnistui",
			"missingScale": "Valitse mittakaava",
			"missingUnit": "Valitse yksikkö",
			"invalidScale": "Mittakaavan on oltava positiivinen suhde, kuten 1:100"
		},
		"measure": {
			"title": "Mittaukset",
			"selected": "{{count}} valittu",
			"selectAll": "Valitse kaikki",
			"clearSelection": "Tyhjennä valinta",
			"clearAll": "Tyhjennä kaikki",
			"scale": "Mittakaava: {{scale}} ({{unit}})",
			"scaleMissing": "Mittakaavaa ei ole asetettu",
			"editScale": "Muuta mittakaavaa",
			"display": "Näytä",
			"totalArea": "Kokonaispinta-ala {{value}}",
			"totalLength": "Kokonaispituus {{value}}",
			"empty": "Ei vielä mittauksia. Piirrä piirustukseen lisätäksesi mittauksia.",
			"locate": "Paikanna mittaus",
			"delete": "Poista mittaus",
			"select": "Valitse {{value}}",
			"deselect": "Poista valinta {{value}}",
			"color": "Mittauksen väri",
			"newColor": "Uusien mittausten väri",
			"selectionColor": "Valinnan väri",
			"auto": "Auto",
			"autoColor": "Automaattinen väri",
			"customColor": "Mukautettu",
			"hue": "Sävy",
			"hex": "Heksaväri",
			"back": "Takaisin",
			"tools": {
				"distance": "Etäisyys",
				"path": "Reitti",
				"area": "Pinta-ala",
				"snap": "Tartu",
				"angle": "Kulma­lukitus",
				"clear": "Tyhjennä"
			}
		},
		"picker": {
			"title": "Työpaketit",
			"searchPlaceholder": "Hae nimellä, koodilla tai sähkönumerolla",
			"root": "Kaikki ryhmät",
			"loadMore": "Näytä lisää",
			"empty": "Paketteja ei löytynyt",
			"tabBrowse": "Selaa",
			"tabRecents": "Viimeksi",
			"noRecents": "Ei vielä viimeksi käytettyjä paketteja",
			"ownGroup": "Omat paketit",
			"ungroupedGroup": "Ryhmittelemättömät",
			"incompatibleReason": "Yksikkö ei sovi",
			"tabFavorites": "Suosikit",
			"noFavorites": "Ei vielä suosikkipaketteja — merkitse paketti tähdellä",
			"variantCount": "{{count}} asennustapaa",
			"variantCount_one": "{{count}} asennustapa",
			"favorite": "Suosikki"
		},
		"colorMode": {
			"title": "Väritys",
			"package": "Paketin mukaan",
			"category": "Luokan mukaan",
			"classification": "Nimikkeen mukaan",
			"system": "Järjestelmän mukaan",
			"custom": "Omat värit"
		},
		"area": {
			"added": "Alue lisätty",
			"drawHint": "Napauta piirustusta rajataksesi alueen; sulje napauttamalla ensimmäistä pistettä",
			"quantityLabel": "Määrä",
			"rawLabel": "Mitattu ala",
			"perimeterLabel": "Piiri",
			"labelLabel": "Nimitys",
			"finish": "Viimeistele alue",
			"createMeasurement": "Luo mittaus",
			"createHint": "Alue suljettu — tallenna painamalla Luo mittaus",
			"sectionTitle": "Aluemittaus"
		},
		"point": {
			"selectHint": "Valitse yksi tai useampi symboli piirustuksesta",
			"addHint": "Napauta piirustusta lisätäksesi pisteen",
			"added": "Piste lisätty",
			"addMeasurement": "Lisää mittaus"
		},
		"measurement": {
			"added": "Mittaus lisätty",
			"addedCount_one": "{{count}} mittaus lisätty",
			"addedCount_other": "{{count}} mittausta lisätty",
			"noLineGeometry": "Valinnassa ei ole viivageometriaa reititettäväksi"
		},
		"wireRun": {
			"noExtension": "Ei enempää jatkettavaa osuutta.",
			"atMinimum": "Johtoreitti on lyhimmillään.",
			"noConnectedSegments": "Yhtenäisiä johto-osuuksia ei löytynyt.",
			"stillLoading": "Piirustus latautuu vielä — yritä hetken kuluttua uudelleen."
		},
		"autoTune": {
			"tuned": "Valinnan ryhmittely viritetty: {{granularity}} (pisteet {{score}})",
			"nothingToGroup": "Automaattiviritys ei löytänyt ryhmiteltävää tältä sivulta.",
			"failed": "Automaattiviritys epäonnistui."
		},
		"entry": {
			"untargetedWarning": "Työpakettia ei ole määritetty — ei mukana arviossa",
			"position": "Sijainti",
			"factor": "Kerroin",
			"package": "Työpaketti",
			"noPackage": "Ei pakettia",
			"packageSelected": "Paketti valittu",
			"color": "Väri",
			"noSystemMatches": "Järjestelmiä ei löytynyt",
			"delete": "Poista mittaus",
			"incompatiblePackage": "Tämän paketin yksikkö ei ole yhteensopiva mittauksen kanssa"
		},
		"search": {
			"presets": {
				"strict": "Tiukka",
				"normal": "Normaali",
				"loose": "Väljä"
			},
			"advanced": "Lisäasetukset",
			"minScore": "Osumakynnys",
			"sizeTolerance": "Kokotoleranssi",
			"run": "Etsi samankaltaiset",
			"matchCount": "{{included}} / {{count}} osumaa mukana",
			"matchRow": "Osuma {{index}} · {{score}} %",
			"assignAll": "Lisää {{count}} mittausta",
			"clear": "Tyhjennä tulokset",
			"title": "Symbolihaku"
		},
		"route": {
			"drafting": {
				"draw": "{{count}} pistettä asetettu — kaksoisnapsauta tai Valmis viimeistelläksesi"
			},
			"pickCable": "Valitse kaapeli…",
			"removeSegment": "Poista osuus",
			"gapSegment": "Väli",
			"gapSegmentHint": "Ei kaapelia: yhdistää tämän mittauksen kaksi erillistä osaa. Ei lasketa pituuteen.",
			"reconnectSegment": "Yhdistä",
			"changeCable": "Vaihda kaapeli…",
			"finish": "Viimeistele reitti",
			"segment": "Osuus {{index}}",
			"segments": "Osuudet",
			"deltaH": "Δh",
			"deltaHTooltip": "Pystyetäisyys / asennusvara",
			"unmappedWarning": "Määrittämättömiä osuuksia — kohdistamattomia metrejä ei lasketa",
			"createMeasurement": "Luo mittaus",
			"selectHint": "Valitse mukaan otettavat kaapelilinjat ja luo sitten mittaus",
			"continueHint": "Napsauta jatkaaksesi reittiä · Esc lopettaa",
			"routing": {
				"title": "Reititys",
				"angle": "Kulmarajoitus",
				"angle90": "Suorakulmainen (90°)",
				"angle45": "Salli 45°",
				"angleFree": "Vapaa",
				"gridRotation": "Ruudukon suunta",
				"gridRotationAuto": "Automaattinen",
				"gridRotationInfo": "Ruudukon suunta: {{degrees}}°",
				"mode": "Tila",
				"mode_exact": "Tarkka",
				"mode_angled": "Kulmitettu",
				"mode_smart": "Älykäs",
				"modeHint_exact": "Uudet mittaukset seuraavat piirrettyä reittiä sellaisenaan.",
				"modeHint_angled": "Uudet mittaukset yksinkertaistetaan ja kohdistetaan kulmaruudukkoon.",
				"modeHint_smart": "Uudet mittaukset yksinkertaistetaan kuten Kulmitettu-tilassa; Laske reitti kohdistaa valitun mittauksen vahvistettuihin seiniin ja hyllyihin.",
				"variantMap": "Kaapeli ohjaimittain",
				"variantMapDesc": "Mikä mittauksen kaapelin asennustapa osuudelle tulee, kun se kulkee hyllyllä tai seinää pitkin. Muistetaan kaapelikohtaisesti.",
				"variantMap_tray": "Hylly",
				"variantMap_wall": "Seinä",
				"variantNone": "Ei kaapelia",
				"variantSingle": "Yksi asennustapa",
				"guideLayers": "Ohjaintasot",
				"guideLayersDesc": "Piirustuksen tasot, joiden seiniin ja hyllyihin älykäs reititys kohdistaa tällä sivulla. Poimi: valitse seinä tai hylly, napauta yhtä viivaa tasoa kohden piirustuksesta, vahvista. Silmä- ja tarkennuspainikkeet muuttavat vain sitä, mitä piirustus näyttää — piilotettujen tasojen ohjaimet reitittävät silti.",
				"guideLayersEmpty": "Tällä sivulla ei ole vielä ohjaimia.",
				"useForRouting": "Käytä reitityksessä",
				"guideHighlights": "Korosta ohjaimet piirustuksessa",
				"isolateGuideLayers": "Näytä vain ohjaintasot",
				"clearGuides": "Tyhjennä",
				"clearGuidesDesc": "Poista kaikki tämän sivun ohjaimet (kumoa Ctrl+Z).",
				"guidesCleared": "{{count}} ohjainta poistettu",
				"pickKind_wall": "Seinät",
				"pickKind_tray": "Hyllyt",
				"pick": "Poimi…",
				"pickKindDesc": "Mitä seuraava poiminta lisää: seinäviivoja vai kaapelihyllyjä.",
				"pickStatus_wall": "Poimitaan seiniä: {{count}} tasoa",
				"pickStatus_tray": "Poimitaan hyllyjä: {{count}} tasoa",
				"pickHint": "Napauta yhtä viivaa tasoa kohden. Kaikki napautuksen alla olevat tasot listataan — rastita seinä- tai hyllytaso, poista rasti teksti- ja rasteritasoilta. Vahvista lopuksi.",
				"pickLayersUnderClick": "Napautusten alla olevat tasot",
				"pickConfirm": "Lisää {{count}} tasoa",
				"snapTolerance": "Hakuetäisyys",
				"snapToleranceDesc": "Kuinka kaukaa alkuperäisen piirustuksen viivasta älyreititys etsii seiniä ja hyllyjä. Tätä lähempänä ohjainta oleva (ja suunnilleen sen suuntainen) osuus siirretään ohjaimelle. Näytetään vyöhykkeenä valitun reitin ympärillä.",
				"toleranceBandLabel": "± {{value, number(maximumFractionDigits: 2)}} m",
				"deviationBandLabel": "enint. {{value, number(maximumFractionDigits: 2)}} m",
				"computing": "Lasketaan reittiä…",
				"computeError": "Reitin laskenta epäonnistui: {{message}}",
				"retry": "Yritä uudelleen",
				"legKinds": "{{onGuide}} / {{total}} osuutta ohjaimilla",
				"detectRunning": "Tunnistetaan…",
				"detectEmpty": "Tasoilta {{layers}} ei löytynyt {{kind}} — napauta viivaa itse seinä- tai hyllytasolla (ei teksti- tai rasteritasolla).",
				"detectEmptyKind_wall": "seinäviivoja",
				"detectEmptyKind_tray": "hyllyviivoja",
				"detectRunningLayers": "Tunnistetaan tasoilta {{layers}}…",
				"guideStale": "{{count}} vanhentunutta — piirustus on muuttunut lisäyksen jälkeen; tyhjennä ja poimi uudelleen.",
				"recorder": "Opetustapaukset",
				"recorderDesc": "Kehitystyökalu: kerää reittejä älyreitityksen virittämiseen. Reititä merkintä, korjaa sen polku halutuksi reitiksi ja lisää se; Vie kirjoittaa jokaisen lisätyn merkinnän nykyisen polun odotetuksi reitiksi testiaineistoon (bun routing:import). Tallennetaan vain tähän selaimeen.",
				"recorderCount": "{{count}} tällä sivulla",
				"recorderAdd": "Lisää",
				"recorderAddDesc": "Tallenna valittu merkintä (piirretty geometria + nykyinen polku) opetustapaukseksi.",
				"recorderRemove": "Poista",
				"recorderRemoveDesc": "Unohda valitun merkinnän opetustapaus.",
				"recorderExport": "Vie",
				"recorderExportDesc": "Lataa tämän sivun tapaukset routing-export-JSON-tiedostona.",
				"recorderClearDesc": "Unohda kaikki tämän sivun opetustapaukset.",
				"recorderNoDrawn": "Valitun merkinnän piirretty geometria ei ole saatavilla tällä sivulla — sitä ei voi tallentaa.",
				"recorderSkipped": "{{count}} tapausta ohitettu: niiden merkintöjä ei enää ole.",
				"guideSelected_wall": "Valittu ohjain: seinä",
				"guideSelected_tray": "Valittu ohjain: hylly",
				"deleteGuide": "Poista ohjain",
				"detectUnavailableLayer": "Tällä tasolla ei ole viivadataa.",
				"detectUnavailablePage": "Tässä piirustuksessa ei ole viivadataa.",
				"detectError": "Tunnistus epäonnistui: {{message}}",
				"guidesConfirmed": "{{count}} ohjainta lisätty",
				"execute": "Laske reitti",
				"preview": "Esikatselu",
				"executeHintNoEntry": "Valitse reittimittaus reitittääksesi sen uudelleen.",
				"modeDesc": "Miten uudet pituusmittaukset reititetään ja mitä Laske reitti tekee valitulle mittaukselle.",
				"angleDesc": "Sallitut osuuksien suunnat yksinkertaistuksen jälkeen. Älytilassa tämä ohjaa ohjainten välisiä vapaita osuuksia; ohjaimella olevat osuudet seuraavat ohjainta.",
				"angle90Desc": "Jokainen osuus vaaka- tai pystysuora ruudukossa (L-kulmat).",
				"angle45Desc": "Sallii myös 45° vinot osuudet (enintään yksi lisämutka osuutta kohden).",
				"angleFreeDesc": "Ei kohdistusta — vain toleranssi- ja lyhin osuus -vaiheet.",
				"gridRotationDesc": "Mitä suuntaa kulmaruudukko seuraa: reittiä itseään, arkin akseleita tai piirustuksesta valitsemaasi viivaa.",
				"gridRotationAutoDesc": "Kohdista ruudukko reitin omaan pääsuuntaan (rakennuksen akseleihin).",
				"gridRotationSheet": "Arkin akselit",
				"gridRotationSheetDesc": "Kohdista ruudukko arkin omiin x/y-akseleihin (0°).",
				"gridRotationPick": "Valitse piirustuksesta",
				"gridRotationPickDesc": "Napsauta seinää tai viivaa piirustuksessa — ruudukko seuraa sen suuntaa. Napsauta uudelleen peruuttaaksesi.",
				"gridRotationPicking": "Napsauta viivaa piirustuksessa asettaaksesi ruudukon suunnan (Esc peruuttaa).",
				"gridRotationPicked": "Ruudukon suunnaksi asetettiin {{degrees}}° valitusta viivasta.",
				"gridRotationPickFailed": "Valitulla kohteella ei ole seurattavaa viivan suuntaa.",
				"toleranceDesc": "Pienet mutkat suoristetaan: laskettu reitti saa poiketa alkuperäisen piirustuksen viivasta enintään tämän verran. Suurempi arvo = vähemmän kulmia.",
				"minLengthDesc": "Tätä lyhyemmät osuudet sulautetaan naapuriin, kun kulmat pysyvät sallittuina.",
				"tolerance": "Suurin poikkeama",
				"minLength": "Lyhin osuus",
				"lengthDelta": "Pituus: {{before}} m → {{after}} m ({{signedDelta}} m, {{signedPct}} %)",
				"lengthDeltaNoPct": "Pituus: {{before}} m → {{after}} m ({{signedDelta}} m)",
				"apply": "Käytä",
				"confirm": "Vahvista",
				"rerouteConfirm": "Reittiä on muokattu käsin. Korvaa uudella reitillä?",
				"droppedWarning": "Osuuksien kaapelit ja Δh-arvot nollattiin. Aiempi pystysuora yhteismatka: {{totalDeltaH}} m — syötä arvot uudelleen osuuksittain.",
				"deviation": "Arvioitu suurin poikkeama: {{meters}} m",
				"staleNotice": "Reitti muuttui muualla — suorita reititys uudelleen.",
				"rerun": "Suorita uudelleen",
				"noLength": "Reitillä ei ole mitattavaa pituutta.",
				"noSource": "Reitin taustalla olevaa piirrettyä geometriaa ei löydy tältä sivulta — avaa sivu, jolta mittaus tehtiin."
			}
		},
		"grouping": {
			"title": "Valinnan ryhmittely",
			"granularity": {
				"baked": "Valmis",
				"tight": "Tiukka",
				"medium": "Keskitaso",
				"loose": "Väljä"
			},
			"scope": {
				"layer": "Tämä taso",
				"nearby": "Lähellä",
				"all": "Kaikki tasot"
			},
			"auto": "Automaattinen",
			"tuning": "Hienosäätö…",
			"streamGap": "Virran väli",
			"connectGap": "Yhdistämisväli",
			"clusterDist": "Klusteriväli",
			"autoDist": "Autom. väli",
			"autoDistTitle": "Johda klusteriväli napsautuskohtaisesti paikallisesta välihistogrammista"
		},
		"settings": "Asetukset",
		"loadingProgress": {
			"title": "Ladataan piirustusta",
			"steps": {
				"download": "Ladataan",
				"process": "Käsitellään",
				"render": "Renderöidään",
				"sync": "Synkronoidaan"
			}
		},
		"layerConfig": {
			"title": "Tasoasetukset",
			"button": "Tasoasetukset",
			"name": "Nimi",
			"namePlaceholder": "Tasoasetuksen nimi",
			"description": "Kuvaus",
			"descriptionPlaceholder": "Vapaaehtoinen kuvaus",
			"setDefault": "Aseta oletukseksi",
			"save": "Tallenna",
			"apply": "Käytä",
			"delete": "Poista",
			"default": "Oletus",
			"empty": "Ei tallennettuja tasoasetuksia.",
			"nameTooShort": "Nimessä on oltava vähintään {{min}} merkkiä.",
			"saved": "Asetukset tallennettu",
			"saveFailed": "Asetuksien tallennus epäonnistui",
			"deleteFailed": "Asetuksien poisto epäonnistui"
		},
		"layerManager": {
			"title": "Tasot",
			"titleFiltered": "Tasot ({{shown}}/{{total}})",
			"titleAll": "Tasot ({{total}})",
			"filterPlaceholder": "Suodata tasoja...",
			"close": "Sulje tasovalikko",
			"showHidden": "Näytä piilotetut tasot",
			"showLayer": "Näytä taso",
			"hideLayer": "Piilota taso",
			"pinLayer": "Kiinnitä taso",
			"unpinLayer": "Poista kiinnitys",
			"lockSelection": "Lukitse valinta",
			"enableSelection": "Salli valinta",
			"showAll": "Näytä kaikki",
			"hideAll": "Piilota kaikki",
			"lockAll": "Lukitse kaikki",
			"unlockAll": "Avaa kaikki",
			"pinAll": "Kiinnitä kaikki",
			"unpinAll": "Poista kaikki kiinnitykset",
			"restoreDefaults": "Palauta oletukset",
			"show": "Näytä",
			"hide": "Piilota",
			"lock": "Lukitse",
			"unlock": "Avaa",
			"pin": "Kiinnitä",
			"unpin": "Irrota",
			"reset": "Palauta"
		},
		"classification": {
			"title": "Luokittelu",
			"scheme": "Nimikkeistö",
			"showAll": "Näytä kaikki nimikkeistöt",
			"search": "Hae luokitusta",
			"back": "Takaisin",
			"clear": "Poista luokitus",
			"unclassified": "Luokittelematon",
			"mixed": "Useita arvoja",
			"system": "Järjestelmä",
			"systemHint": "Valinnainen. Lisää tunnus (esim. L.01) erottaaksesi saman luokituksen kohteet toisistaan.",
			"nodeOnly": "Vain tyyppi (ei järjestelmää)",
			"createSystem": "Lisää tunnus",
			"systemName": "Järjestelmän nimi",
			"systemTunnus": "Tunnus",
			"addSystem": "Lisää järjestelmä",
			"usedInTakeoff": "Käytetty tässä laskennassa",
			"position": "Positio",
			"positionMixedPlaceholder": "Useita arvoja — jätä ennalleen",
			"save": "Tallenna",
			"cancel": "Peruuta",
			"selected": "Valittu luokitus",
			"stale": "Vanhentunut luokitus"
		},
		"preparingSelection": "Valmistellaan valintaa…",
		"marker": {
			"capReached": "Valintaraja saavutettu ({{max}} kohdetta)",
			"belongsToOtherEntry": "Kuuluu jo toiseen mittaukseen",
			"alreadySelected": "Jo valittu – poista pyyhekumilla",
			"nothingToErase": "Tässä ei ole mitään valittua poistettavaksi",
			"outsideFocus": "Fokus lukittu: vain fokustasoilta voi valita",
			"outsideFocusRelease": "Vapauta lukitus valitaksesi muilta tasoilta",
			"controls": {
				"toolbar": "Valintatyökalut",
				"marker": "Korostuskynä (M)",
				"eraser": "Pyyhekumi (E)",
				"undo": "Kumoa valinta (Ctrl+Z)",
				"redo": "Tee valinta uudelleen (Ctrl+Shift+Z)",
				"size": "Koko",
				"sizeValue": "{{value}} px",
				"settings": "Himmennys",
				"dim": "Himmennä muut tasot (D)",
				"dimStrength": "Himmennettyjen tasojen näkyvyys",
				"focusLock": "Fokuslukitus (L)",
				"tapScope": "Napautus valitsee (G)",
				"tapScopeSmart": "Älykäs",
				"tapScopeGroup": "Ryhmät",
				"tapScopeSingle": "Yksittäin",
				"sizeTapOnly": "Koko koskee älykästä valintaa"
			}
		},
		"minimap": {
			"label": "Pienoiskartta"
		}
	},
	"errors": {
		"invalidTakeoffLink": "Virheellinen määrälaskennan linkki",
		"invalidTakeoffLinkDescription": "Linkistä puuttuu kelvollinen määrälaskennan tunniste.",
		"invalidDrawingLink": "Piirustus ei ole käytettävissä",
		"invalidDrawingLinkDescription": "Tämä tiedosto ei ole määrälaskentaan liitetty piirustus."
	},
	"packageUpdate": {
		"title_one": "Työpaketti päivittyi",
		"title_other": "Työpaketit päivittyivät",
		"description_one": "{{count}} tämän määrälaskennan mittaus käyttää sitä. Päivitetäänkö se käyttämään uutta sisältöä?",
		"description_other": "{{count}} tämän määrälaskennan mittausta käyttää niitä. Päivitetäänkö ne käyttämään uutta sisältöä?",
		"affected_one": "{{count}} mittaus",
		"affected_other": "{{count}} mittausta",
		"keepNote": "Jos ohitat tämän, mittaukset säilyttävät sen sisällön, jolla ne on tehty. Voit päivittää ne myöhemmin.",
		"notNow": "Ei nyt",
		"update": "Päivitä mittaukset"
	}
}
